import { useEffect } from 'react';

import { trackEvents } from '@boss/constants/shared';
import { useRouter } from '@boss/hooks';
import { Modal } from '@boss/ui';

import { useEventTracker } from '../../hooks';
import { MagazineCardForm } from '../Form';

interface Translations {
  title: string;
  description?: string;
  subscribe: string;
}

type Props = {
  onCloseModal: (value: boolean) => void;
  onSubmit: (values: { email: string; firstName: string; lastName: string; subscribeNewsletter: boolean }) => void;
  isLoading: boolean;
  translations: Translations;
  popupId: string;
  triggerMethod?: string;
};

const SubscribeModal = ({
  onCloseModal: handleCloseModal,
  onSubmit: handleSubmit,
  isLoading,
  translations,
  popupId,
  triggerMethod = 'button_click',
}: Props) => {
  const { trackCustomEvent } = useEventTracker();
  const { asPath } = useRouter();

  // Tracking
  useEffect(() => {
    trackCustomEvent(trackEvents.POPUP_SHOWN, {
      popup_id: popupId,
      popup_type: 'modal',
      trigger_method: triggerMethod,
      slug: asPath,
      page_title: document.title,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Modal className="md:max-w-[500px]" onClose={() => handleCloseModal(false)}>
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-2">
          <p className="text-lg font-medium">{translations.title}</p>
          {translations.description && <p className="text-sm text-gray-600">{translations.description}</p>}
        </div>

        <MagazineCardForm isSubmitting={isLoading} onSubmit={handleSubmit} submitButtonLabel={translations.subscribe} />
      </div>
    </Modal>
  );
};

export default SubscribeModal;
